import React, { useState } from "react";
import { TicketAnswerDto, TicketDetailDto } from "src/store/ticket/type";
import Lightbox from "react-image-lightbox";
import images from "src/assets/image";
import { baseUrl } from "src/request/types";
const TicketMessageContainer = ({
  ticket,
  message,
}: {
  ticket: TicketDetailDto;
  message: TicketAnswerDto;
}) => {
  const [isEffects, setisEffects] = useState<boolean>(false);
  return (
    <React.Fragment>
      <div
        className={
          "comment leftMessage " +
          (message.ClientId === null ? " rightMessage" : " leftMessage")
        }
      >
        <div className=" messageBox ">
          <div
            className="text"
            dangerouslySetInnerHTML={{ __html: message.Message }}
          />
          {message.DocumentLocation && (
            <div className="messageBoxFooter">
              {message.DocumentLocation.includes(
                "png" || "jpg" || "jpeg" || "svg"
              ) ? (
                <>
                  <img
                    className="cursor-pointer"
                    style={{
                      cursor: "pointer",
                      boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
                    }}
                    src={baseUrl + message.DocumentLocation}
                    width={50}
                    alt=""
                    onClick={() => {
                      setisEffects(!isEffects);
                    }}
                  />
                  {isEffects ? (
                    <Lightbox
                      mainSrc={baseUrl + message.DocumentLocation}
                      enableZoom={true}
                      onCloseRequest={() => {
                        setisEffects(!isEffects);
                      }}
                    />
                  ) : null}
                </>
              ) : (
                <img
                  className="cursor-pointer"
                  style={{
                    cursor: "pointer",
                    boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
                  }}
                  src={images.filedownload}
                  width={30}
                  alt=""
                  onClick={() => {
                    window.open(baseUrl + message.DocumentLocation, "_blank");
                  }}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default TicketMessageContainer;
